import { BroadcastsList } from "./broadcasts-list";

interface ProjectBroadcastsTabProps {
  projectId: string;
}

/**
 * Broadcasts for ONE project (Project Settings → Broadcasts) — set a schedule where you built the
 * thing, instead of going hunting in workspace settings.
 *
 * It is a scoped view, not a second home: the list is the workspace's broadcasts filtered
 * server-side to those capturing this project, and a broadcast that also captures other projects
 * is read-only here with a link out. Editing it from inside one project used to silently change
 * what the other projects' owners received, which is why this tab was removed once already.
 */
export function ProjectBroadcastsTab({
  projectId,
}: ProjectBroadcastsTabProps): JSX.Element {
  return <BroadcastsList scope={{ kind: "project", projectId }} />;
}
